<script>
    import { onMount } from "svelte";

    import { fly } from "svelte/transition";

    import { showSidebar } from "../stores.js";
    import { fetchGet } from "../utils/utilsFetch.js";

    let categories = [];

    onMount(async () => {
        categories = await fetchGet("/api/categories");
    });

    let activeCatName;
</script>

<div
    class="container"
    class:visible={$showSidebar}
    in:fly={{ x: -300, duration: 500 }}
    out:fly={{ x: -300, duration: 500 }}
>
    {#each categories as category}
        <a
            href={category.type == "view"
                ? `/${category.name}`
                : `/products?${category.type}=${category.name}`}
        >
            <div
                class="category list-item"
                class:sale={category.name == "Akcija"}
                class:new={category.name == "Novo"}
                on:mouseenter={() => {
                    activeCatName = category.name;
                }}
            >
                <div class="name">
                    {category.name}
                </div>

                <div class="count">
                    {category.productsCount.toLocaleString()}
                </div>
            </div>
        </a>
    {/each}
</div>

<style>
    .container {
        grid-column: 1/2;
        grid-row: 2/-1;

        display: flex;
        z-index: 97;

        font-size: 14px;

        flex-direction: column;
        box-shadow: 0px 0px 2px #888;

        display: none;
    }

    .visible {
        display: block;
    }

    .list-item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ccc;
        cursor: pointer;

        padding: 7px 10px;
    }

    .list-item:hover {
        background: #ddd;
    }

    .count {
        margin-left: auto;
        opacity: 0.4;
    }

    .sale {
        background: #ede321;
        font-weight: bold;
    }

    .sale:hover {
        background: #bdb418;
    }

    .new {
        background: #217ded;
        font-weight: bold;
    }

    .new:hover {
        background: #1a62bb;
    }
</style>
